import { render, staticRenderFns } from "./Done.vue?vue&type=template&id=6fc46c54"
var script = {}
import style0 from "./Done.vue?vue&type=style&index=0&id=6fc46c54&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/listfinder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc46c54')) {
      api.createRecord('6fc46c54', component.options)
    } else {
      api.reload('6fc46c54', component.options)
    }
    module.hot.accept("./Done.vue?vue&type=template&id=6fc46c54", function () {
      api.rerender('6fc46c54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/auth/password-reissue/Done.vue"
export default component.exports